export const dayClick = (day) => {
    return {
        type: 'DAY_CLICK',
        day,
    }
}

export const editComplete = (day) => {
    return {
        type: 'EDIT_COMPLETE',
    }
}

export const editIncomplete = (day) => {
    return {
        type: 'EDIT_INCOMPLETE',
    }
}


export const calculatePrices = () => {
    return {
        type: 'RANGES_CHANGED'
    }
}
export const updateLengthOfStay = () => {
    return {
        type: 'UPDATE_LENGTHOFSTAY'
    }
}

export const dayClickAndCalculate = (day) => {
    return dispatch => {
        dispatch(dayClick(day));
        dispatch(updateLengthOfStay());
        dispatch(calculatePrices());
    }
}

export const dayMouseOver = (day) => {
    return {
        type: 'DAY_MOUSE_OVER',
        day,
    }
}

export const dayMouseOverAndCalculate = (day) => {
    return dispatch => {
        dispatch(dayMouseOver(day));
        dispatch(calculatePrices());
    }
}

export const nextMonth = () => {
    return {
        type: 'NEXT_MONTH'
    }
}

export const previousMonth = () => {
    return {
        type: 'PREVIOUS_MONTH'
    }
}

export const firstAvailablePeriod = () => {
    return {
        type: 'FIRST_AVAILABLE_PERIOD'
    }
}
